module.exports = __webpack_public_path__ + "img/品牌赛事_5@2x.792f1008.png";